import { createAction, props } from '@ngrx/store';
import { PerguntaFrequenteInputDto } from 'src/app/domain/DTOs/input/perguntas-frequentes.input.dto';
import { EstruturaRetornoDadosOutputDto } from 'src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto';
import { PerguntaFrequenteOutputDto } from 'src/app/domain/DTOs/output/pergunta-frequente.output.dto';

const actionName = "[ ListarPerguntasFrequentes ] Listar perguntas frequentes";

export const listarPerguntasFrequentes = createAction(
  actionName,
  props<{ perguntasFrequentesInputDto: PerguntaFrequenteInputDto}>()
);

export const listarPerguntasFrequentesSuccess = createAction(
  `${actionName} - Sucesso`,
  props<{ response: EstruturaRetornoDadosOutputDto<PerguntaFrequenteOutputDto[]> }>()
);

export const listarPerguntasFrequentesFailure = createAction(
  `${actionName} - Falha`,
  props<{ response: EstruturaRetornoDadosOutputDto<PerguntaFrequenteOutputDto[]> }>()
);

export const listarPerguntasFrequentesFinish = createAction(
  `${actionName} - Concluir`
);
